import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL_Titania

export const axiosTna = axios.create({
    baseURL: API_URL,
    withCredentials: true
})
